import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSearch } from 'src/hooks/use-search';
import { editExclusionZonePromise, type EditExclusionZonePromiseParam } from 'src/utils/api/edit-exclusion-zone';
import { QUERY_KEY_MAP } from 'src/constants';
import { clearShapesFn } from 'src/components/ZoneEditor/context';
import { useNotification } from 'src/hooks';

export const useEditExclusionZone = () => {
  const queryClient = useQueryClient();
  const { enqueueSuccessNotification } = useNotification();

  const [searchParams] = useSearch();
  const deviceId = searchParams?.device?.id || '';

  const { mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QUERY_KEY_MAP.useEditExclusionZone],
    mutationFn: editExclusionZonePromise,
  });

  const editExclusionZoneAsync = async (data: EditExclusionZonePromiseParam) => {
    try {
      await mutateAsync(data);

      clearShapesFn();
      enqueueSuccessNotification('saved.exclusion.zone');

      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_MAP.useGetZoneLastUpdatedMeta, deviceId],
        }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_MAP.useGetExclusionZoneData, deviceId],
        }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_MAP.useGetDeviceZoneVersionHistory, deviceId],
        }),
      ]);
    } catch (e) {
      console.error(e);
    }
  };

  return {
    editExclusionZoneAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
